import React from 'react';
import { Icon } from 'components';
import { StyledAlert } from '../../components';

const NoAccessAlert = () => (
    <StyledAlert
      dataCy="noAccess-page-alert"
      message={
        <span>
          You do not have access to this feature. Please reach out to your
          managing broker to finish setting up your brokerage.
        </span>
      }
      type="warning"
      showIcon
      icon={
        <Icon type="antdExclamationCircleFilled" color="warning" width={14} />
      }
    />
  );

export default NoAccessAlert;
